module.exports = __webpack_public_path__ + "img/photo-1614308460927-5024ba2e1dcb.0dfb6569.jpeg";